import { NewClientAccountControlDetails } from '@repo/ui/NewClientAccountControlDetails'
import { NewClientCheckExisting } from '@repo/ui/NewClientCheckExisting'
import { NewClientDetails } from '@repo/ui/NewClientDetails'
import { NewClientExtensions } from '@repo/ui/NewClientExtensions'
import { NewClientPhoneNumbers } from '@repo/ui/NewClientPhoneNumbers'
import { NewClientSummary } from '@repo/ui/NewClientSummary'
import { useNewClientStore } from '@repo/store/useNewClientStore'

export default [
  {
    stageLabel: 'Create new client',
    stageId: 'client',
    resetData: useNewClientStore.getState().reset,
    steps: [
      {
        stepLabel: 'Client details',
        stepDescription: 'Please enter the client details',
        stepId: 'client-details',
        skippable: false,
        component: NewClientDetails,
        uniqueId: 'newclient-client-details'
      },
      {
        stepLabel: 'Check for existing clients',
        stepDescription: 'Check if the client already exists',
        stepId: 'check-existing-clients',
        skippable: true,
        component: NewClientCheckExisting,
        uniqueId: 'newclient-check-existing-clients'
      },
      {
        stepLabel: 'Client extensions',
        stepDescription: 'Please enter additional details for the client',
        stepId: 'client-extensions',
        skippable: true,
        component: NewClientExtensions,
        uniqueId: 'newclient-extensions'
      },
      {
        stepLabel: 'Phone numbers',
        stepDescription: 'Add phone numbers for the client',
        stepId: 'phone-numbers',
        skippable: true,
        component: NewClientPhoneNumbers,
        uniqueId: 'newclient-phone-numbers'
      },
      {
        stepLabel: 'Account control details',
        stepDescription: 'Set debt limits against the client',
        stepId: 'account-control-details',
        skippable: true,
        component: NewClientAccountControlDetails,
        uniqueId: 'newclient-client-account-control-details'
      },
      {
        stepLabel: 'Summary',
        stepDescription: 'New client added',
        stepId: 'summary',
        skippable: true,
        component: NewClientSummary,
        uniqueId: 'newclient-client-summary'
      }
    ]
  }
]
